import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import * as countryConfig from '../../../assets/config/country.json';
import _ from 'lodash';

@Injectable()

export class ConfigService {

	fieldConfig = null;
	countryFieldConfigs: any = {};

	appName = 'Contingent Labor on IBM Blockchain';
	purchaseOrderDataObj = 'purchaseorder';
	contractorDataObj = 'contractor';
	pendingContractorDataObj = 'contractor-pending';
	timesheetDataObj = 'timesheet';
	pendingTimesheetDataObj = 'timesheet-pending';
	smartContractDataObj = 'smartcontract';
	dtvScheduleDataObj = 'dtvschedule';
	dtvScheduleSCDataObj = 'dtvschedulesmartcontract';
	poSCDataObj = 'posmartcontract';
	contractorSCDataObj = 'contractorsmartcontract';
	timesheetSCDataObj = 'timesheetsmartcontract';
	userRequestDataObj = 'userrequest';
	userDataObj = 'user';
	timesheetsRangeDataObj = 'timesheetsrange';
	invoiceSCDataObj = 'invoicesmartcontract';
	supplierInvoiceSCDataObj = 'supplierinvoicesmartcontract';

	// Core config props used is all objects
	poConnector = 'poconnector';
	poNumberProp = 'ponumber';
	shortTextProp = 'shorttext';
	supplierIdProp = 'supplierid';
	prevPOSupplierIdProp = 'prevposupplierid';
	startDateProp = 'startdate';
	endDateProp = 'enddate';
	accountsProp = 'accounts';
	uuidProp = 'uuid';
	lineItemIndexProp = 'lineitemindex';
	poLineItemsProp = 'items';

	// Purchase Order config props
	renewalPOProp = 'renewalpo';
	previousPOProp = 'prevponum';
	poStartDateProp = 'postartdate';
	poEndDateProp = 'poenddate';
	poIssueDateProp = 'poissuedate';
	poItems = 'items';
	poItemsStartDate = 'items.startdate';
	poItemsEndDate = 'items.enddate';
	calendarIdProp = 'calendarid';
	calendarIsDefaultProp = 'isdefault';

	// Invoice Calendar config props
	invoiceCalNameProp = 'name';
	invoiceCalIdProp = 'id';
	invoiceCalIsMonthlyProp = 'ismonthly';

	// Contractor config props
	contractorIdProp = 'uuid';
	contractorLineItemProp = 'poconnector';
	contractorNameProp = 'contractorname';
	contractorStartProp = 'actualstartdate';
	contractorEndProp = 'actualenddate';
	contractorPendingStatus = 'pending';
	supcontIdProp = 'suppliercontractorid';
	contractorMergeProp = 'mergecontractor';
	contractorDeleteProp = 'deletecontractor';
	contractorILCProp = 'ilcenabled';
	contractorEditcodeProp = 'editcode';
	contractorEditdescProp = 'editdesc';
	contractorAddonsProp = 'flexifields';

	// Contractor config props
	buyerContractorId = 'buyercontractorid';
	buyercontractoremail = 'buyercontractoremail';
	ilcSerialNumProp = 'ilcserialnum';
	supplierContractorId = 'suppliercontractorid';
	countryCodeProp = 'countrycode';

	// Timesheet config props
	timeentryProp = 'timeentryforperiod';
	timesheetDocsProp = 'timesheetdocs';
	timesheetApprovalPeriodProp = 'approvalfor';
	timesheetCommentProp = 'rejectioncomment';
	timesheetSaveStatus = 'SAVE';
	timesheetSubmitStatus = 'SUBMIT';
	timesheetUnsubmitStatus = 'Unsubmitted';
	timesheetApprovalObjProp = 'approval';
	timesheetSAMApprovalFieldProp = 'supplierapproval';
	timesheetSAMSubmitStatus = 'Self approval';
	timesheetApprovalProp = 'approvalstatus';
	timesheetSAMApprovalStatusProp = 'supplierapprovalstatus';
	timesheetPMApprovalStatusProp = 'buyerapprovalstatus';
	timesheetApprovalStatus = 'approved';
	timesheetPendingStatus = 'pending';
	timesheetPedingStatusDescription = 'Pending approval';
	timesheetPendingSAM = 'Pending SAM approval';
	timesheetPendingMGR = 'Pending Mgr approval';
	timesheetRejectedStatus = 'rejected';
	timesheetInvoicedStatus = 'Invoiced';
	timesheetSAMRejectedStatus = 'rejected by SAM';
	timesheetPMRejectedStatus = 'rejected by Mgr';
	timesheetRejectedSAM = 'rejected by the supplier account manager';
	timesheetRejectedMGR = 'rejected by the manager';
	timesheetArchiveProp = 'archive';
	timesheetSavedNote = 'This timesheet has been saved.';
	timesheetStartProp = 'startdate';
	timesheetEndProp = 'enddate';
	timesheetApprovalTimeProp = 'approvaldatetime';
	timesheetLatestSubmissionDateProp = 'latestsubmissiondate';
	timesheetBuyerApprovalTimeProp = 'buyerapprovaldatetime';
	timesheetSupplierApprovalTimeProp = 'supplierapprovaldatetime';
	timesheetStatusProp = 'statusdescription';
	timesheetStatusUIProp = 'statusuidescription';
	timesheetInvoiceStatusProp = 'invoicestatus';
	timesheetReasonSubmittedStatus = 'Reason Code Submitted';
	timsheetHoursProp = 'totalhours';
	timsheetSTHoursProp = 'totalSThours';
	timsheetOTHoursProp = 'totalOThours';
	timsheetDTHoursProp = 'totalDThours';
	timesheetIsCRRReconciledProp = 'iscrrreconciled';
	timsheetNonbillableHoursProp = 'totalnonbillable';
	timesheetInqueueProp = 'inqueue';
	timesheetIDProp = 'id';
	timesheetMigrationProp = 'migration';
	timesheetMigrationUIProp = 'date';
	timesheetHasExpensesProp = 'hasexpenses';
	timesheetCurrencyProp = 'currency';
	timesheetReceiptVal = 75;
	timesheetContractorLockProp = 'disablecontractoredits';
	timesheetSupplierIdProp = 'supplierid';
	timesheetSupplierContIdProp = 'suppliercontractorid';
	timesheetStraightTimeProp = 'straighttime';
	timesheetStandardTimeProp = 'standard';
	timesheetHasCorrectionProp = 'hascorrection';

	// Invoice config props
	// invoiceChaincodeProp = 'chaininvoice';
	invoiceChaincodeProp = 'cleartoinvoice';
	invoiceStartProp = 'billingstart';
	invoiceEndProp = 'billingend';
	// invoiceSupplierProp = 'supplierinvoice';
	invoiceSupplierProp = 'invoicedvalue';
	invoiceRecStatusProp = 'reconciliationstatus';
	invoiceRecPassStatus = 'pass';
	invoiceRecFailStatus = 'failed';
	invoiceNumberProp = 'invoicenumber';
	invoiceKeyProp = 'bcinvkey';
	invoiceStatusProp = 'status';
	invoiceItemsProp = 'items';
	invoiceTypeProp = 'type';
	invoiceStraightTimeProp = 'straighttime';
	invoiceOvertimeProp = 'overtime';
	invoiceDoubletimeProp = 'doubletime';
	invoiceExpensesProp = 'expenses';
	invoiceItemAmtProp = 'grossamt';
	invoiceInvoiceAmtProp = 'grossamount';
	invoiceDateProp = 'invoicedate';
	invoiceHelpProp = 'helptext';
	invoiceBillingPeriodsProp = 'events';
	invoiceDatesProp = 'invoicedates';
	invoiceCalendarProp = 'invoicecalendarname';

	// Smart Contract config props
	smartContractTypeProp = 'smartcontracttype';
	smartContractApprovalStatus = 'approved';
	smartContractRejectedStatus = 'rejected';
	dtvPermanentProp = 'permanent';

	// User Request config props
	userRequestOrgProp = 'org';

	// Validation props used to display custom inputs (other than text fields)
	validateDateProp = 'date';
	validateNumberProp = 'number';
	validateQuantityTypeProp = 'quantitytype';
	validateBooleanProp = 'boolean';
	validateApprovalProp = 'approval';
	validateCommentProp = 'comment';
	validateTRAProp = 'tra';
	validatePMProp = 'pm';
	validateSAMProp = 'sam';
	validateCCAProp = 'cca';
	validatePasswordProp = 'password';
	validateDateArrayProp = 'datearray';
	validateCalendarEntriesProp = 'calendarEntries';
	validateTimestampProp = 'timestamp';
	validateEmailProp = 'email';
	validateRoleProp = 'role';
	validateArrayProp = 'array';

	// API Result Props
	detailDataProp = 'detail';
	detailValueProp = 'value';
	recordsDataProp = 'records';
	errorDataProp = 'error';
	successDataProp = 'success';
	countDataProp = 'count';

	// field Props
	idProp = 'idProp';

	// contractor IDs
	supplierId = '';

	// response code strings
	partialString = 'PARTIAL';

	// paging
	pageSize = 15;

	ssoCompanyProp = 'ssoCompany';

	tempTab = {
		prop: 'temp',
		name: 'Temp',
		active: false,
		persona: ['all'],
		notPersona: [],
		cached: false,
		listTab: false,
		type: 'standard',
		page: 0
	};

	roles = [
		{
			id: 'pm',
			itemName: 'Manager',
			canEdit: 'admin'
		}, {
			id: 'sam',
			itemName: 'Supplier Account Manager',
			canEdit: 'sa'
		}, {
			id: 'srm',
			itemName: 'Supplier Relations Manager',
			canEdit: 'admin'
		}, {
			id: 'contractor',
			itemName: 'Contractor',
			canEdit: 'sa'
		}, {
			id: 'tra',
			itemName: 'Delegated Time Verifier',
			canEdit: 'admin'
		}, {
			id: 'cca',
			itemName: 'Contractor Administrator',
			canEdit: 'admin'
		}, {
			id: 'sa',
			itemName: 'Supplier Administrator',
			canEdit: 'admin'
		}, {
			id: 'fa',
			itemName: 'Finance Analyst',
			canEdit: 'admin'
		}
	];

	rolesByPersona = {
		admin: [
			{
				id: 'pm',
				itemName: 'Manager'
			}, {
				id: 'srm',
				itemName: 'Supplier Relations Manager'
			}, {
				id: 'tra',
				itemName: 'Delegated Time Verifier'
			}, {
				id: 'cca',
				itemName: 'Contractor Administrator'
			}, {
				id: 'pm,tra',
				itemName: 'Manager, Delegated Time Verifier'
			}, {
				id: 'fa',
				itemName: 'Finance Analyst'
			}
		],
		sa: [{
			id: 'sam',
			itemName: 'Supplier Account Manager'
		}, {
			id: 'contractor',
			itemName: 'Contractor'
		}]
	};


	actions = {
		contractor: [{
			name: 'Assign Delegated Time Verifier',
			prop: 'contractorassigntra'
		}, {
			name: 'Update Delegated Time Verifier',
			prop: 'dtvscheduleupdate'
		}, {
			name: 'Remove Delegated Time Verifier',
			prop: 'contractorremovetra'
		}, {
			name: 'Move to Inactive',
			prop: 'contractorarchive'
		}, {
			name: 'Apply Hours Restriction',
			prop: 'hoursrestriction'
		}],
		timesheet: [{
			name: 'Verify/Reject Timesheets',
			prop: 'approvetimesheet'
		}, {
			name: 'Migrate Timesheets',
			prop: 'migratetimesheet'
		}, {
			name: 'Export To CSV',
			prop: 'exporttocsv'
		}],
		purchaseorder: [{
			name: 'Transfer PO',
			prop: 'poroledelegation'
		}, {
			name: 'Move to Inactive',
			prop: 'poarchive'
		}, {
			name: 'Export To CSV',
			prop: 'exporttocsv'
		}],
		archivedpurchaseorder: [{
			name: 'Transfer PO',
			prop: 'poroledelegation'
		}, {
			name: 'Restore to active',
			prop: 'porestore'
		}, {
			name: 'Export To CSV',
			prop: 'exporttocsv'
		}],
		cancellationpurchaseorder: [{
			name: 'Migrate PO',
			prop: 'pomigrate'
		}, {
			name: 'Export To CSV',
			prop: 'exporttocsv'
		}],
		archivedcontractor: [{
			name: 'Restore to active',
			prop: 'contractorrestore'
		}, {
			name: 'Export To CSV',
			prop: 'exporttocsv'
		}],
		cancelledcontractor: [{
			name: 'Export To CSV',
			prop: 'exporttocsv'
		}],
		invoice: [{
			name: 'Force Reconciliation',
			prop: 'forcereconciliation'
		}, {
			name: 'Export To CSV',
			prop: 'exporttocsv'
		}
		],
		pendinginvoice: [{
			name: 'Move to Inactive',
			prop: 'invoicearchive'
		}, {
			name: 'Export To CSV',
			prop: 'exporttocsv'
		}
		],
		archivedinvoice: [{
			name: 'Restore to Active',
			prop: 'invoicerestore'
		}, {
			name: 'Export To CSV',
			prop: 'exporttocsv'
		}
		]
	};

	exportAction = {
		name: 'Export To CSV',
		prop: 'exporttocsv'
	};

	// Persona strings
	persona = '';
	personaIndex = 0;
	personas = [
		{
			prop: 'anon',
			name: 'Anonymous',
			path: 'accept-account',
			paths: [
				'accept-account'
			],
			search: [],
			approve: [],
			timesheetAction: '',
			timesheetEscalation: '',
			headerCounts: false,
			actions: {},
		}, {
			prop: 'admin',
			name: 'Administrator',
			path: 'admin-po',
			paths: [
				'privacy-notice',
				'help',
				'user-config',
				'admin-addons',
				'admin-po',
				'admin-invoice',
				'admin-users',
				'escalation-config',
				'release-notes',
				'logout'
			],
			search: [],
			approve: [],
			timesheetAction: '',
			timesheetEscalation: '',
			headerCounts: false,
			actions: {
				user: [{
					name: 'Revalidate Users',	// this action needs be the first
					prop: 'revalidateusers'
				}, {
					name: 'Revoke Users',
					prop: 'revokeusers'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}]
			},
		}, {
			prop: 'pm',
			name: 'Manager',
			path: 'dashboard',
			paths: [
				'dashboard',
				'privacy-notice',
				'help',
				'user-config',
				'purchase-orders',
				'contractors',
				'timesheets',
				'delegated-time-verifier-schedule',
				'contract-changes',
				'invoices',
				'supplier-invoices',
				'blockchain-invoices',
				'reports',
				'release-notes',
				'logout'
			],
			search: [this.purchaseOrderDataObj, this.contractorDataObj, this.timesheetDataObj],
			approve: [this.contractorDataObj, this.timesheetDataObj],
			timesheetAction: 'You have timesheets pending verification.',
			timesheetEscalation: 'You have escalated timesheets',
			headerCounts: true,
			actions: {
				contractor: [{
					name: 'Assign Delegated Time Verifier',
					prop: 'contractorassigntra'
				}, {
					name: 'Remove Delegated Time Verifier',
					prop: 'contractorremovetra'
				}, {
					name: 'Move to Inactive',
					prop: 'contractorarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}, {
					name: 'Apply Hours Restriction',
					prop: 'hoursrestriction'
				}],
				timesheet: [{
					name: 'Verify/Reject Timesheets',
					prop: 'approvetimesheet'
				}, {
					name: 'Migrate Timesheets',
					prop: 'migratetimesheet'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				purchaseorder: [{
					name: 'Transfer PO',
					prop: 'poroledelegation'
				}, {
					name: 'Move to Inactive',
					prop: 'poarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				archivedpurchaseorder: [{
					name: 'Transfer PO',
					prop: 'poroledelegation'
				}, {
					name: 'Restore to active',
					prop: 'porestore'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				nocontractorspurchaseorder: [{
					name: 'Move to Inactive',
					prop: 'poarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				cancellationpurchaseorder: [{
					name: 'Migrate PO',
					prop: 'pomigrate'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				expiringpurchaseorder: [{
					name: 'Move to Inactive',
					prop: 'poarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				anypurchaseorder: [{
					name: 'Transfer PO',
					prop: 'poroledelegation'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				smartcontract: [
					{
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}
				],
				dtvschedule: [
					{
						name: 'Update Delegated Time Verifier',
						prop: 'dtvscheduleupdate'
					}, {
						name: 'Remove Delegated Time Verifier',
						prop: 'contractorremovetra'
					}
				],
				invoice: [
					{
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}
				],
				archivedcontractor: [{
					name: 'Restore to active',
					prop: 'contractorrestore'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				cancelledcontractor: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				anycontractor: [{
					name: 'Assign Delegated Time Verifier',
					prop: 'contractorassigntra'
				}, {
					name: 'Remove Delegated Time Verifier',
					prop: 'contractorremovetra'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
			}
		}, {
			prop: 'sam',
			name: 'Supplier Account Manager',
			path: 'dashboard',
			paths: [
				'dashboard',
				'privacy-notice',
				'help',
				'user-config',
				'purchase-orders',
				'contractors',
				'timesheets',
				'contract-changes',
				'invoices',
				'supplier-invoices',
				'blockchain-invoices',
				'reports',
				'release-notes',
				'logout'
			],
			search: [this.purchaseOrderDataObj, this.contractorDataObj, this.timesheetDataObj],
			approve: [this.contractorDataObj, this.timesheetDataObj, this.smartContractDataObj],
			timesheetAction: 'You have timesheets pending verification.',
			timesheetEscalation: 'You have escalated timesheets',
			headerCounts: true,
			actions: {
				timesheet: [{
					name: 'Verify/Reject Timesheets',
					prop: 'approvetimesheet'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				purchaseorder: [{
					name: 'Transfer PO',
					prop: 'poroledelegation'
				}, {
					name: 'Move to Inactive',
					prop: 'poarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				archivedpurchaseorder: [{
					name: 'Transfer PO',
					prop: 'poroledelegation'
				}, {
					name: 'Restore to active',
					prop: 'porestore'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				nocontractorspurchaseorder: [{
					name: 'Move to Inactive',
					prop: 'poarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				cancellationpurchaseorder: [{
					name: 'Migrate PO',
					prop: 'pomigrate'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				expiringpurchaseorder: [{
					name: 'Move to Inactive',
					prop: 'poarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				anypurchaseorder: [{
					name: 'Transfer PO',
					prop: 'poroledelegation'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				smartcontract: [
					{
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}
				],
				invoice: [
					{
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}
				],
				pendingsupplierinvoice: [
					{
						name: 'Move To Inactive',
						prop: 'supplierinvoicearchive'
					},
					{
						name: 'Export To CSV',
						prop: 'exporttocsv'
					},
				],
				archivedsupplierinvoice: [
					/* {
						name: 'Change Billing Period',
						prop: 'invoice'
					}, */
					{
						name: 'Restore to active',
						prop: 'supplierinvoiceactivate'
					},
					{
						name: 'Export To CSV',
						prop: 'exporttocsv'
					},
				],
				contractor: [
					{
						name: 'Move to Inactive',
						prop: 'contractorarchive'
					}, {
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}
				],
				archivedcontractor: [
					{
						name: 'Restore to active',
						prop: 'contractorrestore'
					}, {
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}],
				cancelledcontractor: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				anycontractor: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
			}
		}, {
			prop: 'srm',
			name: 'Supplier Relations Manager',
			path: 'purchase-orders',
			paths: [
				'privacy-notice',
				'help',
				'purchase-orders',
				'contractors',
				'contract-changes',
				'release-notes',
				'logout'
			],
			search: [this.purchaseOrderDataObj, this.contractorDataObj],
			approve: [],
			timesheetAction: '',
			timesheetEscalation: '',
			headerCounts: true,
			actions: {
				purchaseorder: [{
					name: 'Move to Inactive',
					prop: 'poarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				archivedpurchaseorder: [{
					name: 'Restore to active',
					prop: 'porestore'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				archivedcontractor: [
					{
						name: 'Restore to active',
						prop: 'contractorrestore'
					}, {
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}
				],
				smartcontract: [
					{
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}
				],
				contractor: [
					{
						name: 'Move to Inactive',
						prop: 'contractorarchive'
					}, {
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}
				]
			}
		}, {
			prop: 'contractor',
			name: 'Contractor',
			path: 'dashboard',
			paths: [
				'dashboard',
				'timesheet',
				'timesheets',
				'privacy-notice',
				'help',
				'user-config',
				'release-notes',
				'logout'
			],
			search: [],
			approve: [],
			timesheetAction: 'You have rejected timesheets requiring edits.',
			timesheetEscalation: '',
			headerCounts: true,
			actions: {}
		}, {
			prop: 'tra',
			name: 'Delegated Time Verifier',
			path: 'timesheets',
			paths: [
				'privacy-notice',
				'help',
				'user-config',
				'contractors',
				'timesheets',
				'reports',
				'release-notes',
				'logout'
			],
			search: [this.timesheetDataObj],
			approve: [],
			timesheetAction: 'You have timesheets pending verification.',
			timesheetEscalation: 'You have escalated timesheets',
			headerCounts: true,
			actions: {
				contractor: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				archivedcontractor: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				cancelledcontractor: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				anycontractor: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				timesheet: [{
					name: 'Verify/Reject Timesheets',
					prop: 'approvetimesheet'
				}, {
					name: 'Migrate Timesheets',
					prop: 'migratetimesheet'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				purchaseorder: [{
					name: 'Transfer PO',
					prop: 'poroledelegation'
				}, {
					name: 'Move to Inactive',
					prop: 'poarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				archivedpurchaseorder: [{
					name: 'Restore to active',
					prop: 'porestore'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}]
			}
		}, {
			prop: 'cca',
			name: 'Contractor Administrator',
			path: 'contractors',
			paths: [
				'privacy-notice',
				'help',
				'user-config',
				'purchase-orders',
				'contractors',
				'delegated-time-verifier-schedule',
				'reports',
				'release-notes',
				'logout'
			],
			search: [this.purchaseOrderDataObj, this.contractorDataObj],
			approve: [this.contractorDataObj],
			timesheetAction: '',
			timesheetEscalation: '',
			headerCounts: true,
			actions: {
				contractor: [{
					name: 'Assign Delegated Time Verifier',
					prop: 'contractorassigntra'
				}, {
					name: 'Remove Delegated Time Verifier',
					prop: 'contractorremovetra'
				}, {
					name: 'Move to Inactive',
					prop: 'contractorarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				anycontractor: [{
					name: 'Assign Delegated Time Verifier',
					prop: 'contractorassigntra'
				}, {
					name: 'Remove Delegated Time Verifier',
					prop: 'contractorremovetra'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				purchaseorder: [{
					name: 'Transfer PO',
					prop: 'poroledelegation'
				}, {
					name: 'Move to Inactive',
					prop: 'poarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				archivedpurchaseorder: [{
					name: 'Transfer PO',
					prop: 'poroledelegation'
				}, {
					name: 'Restore to active',
					prop: 'porestore'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				delegatedpurchaseorder: [{
					name: 'Transfer PO',
					prop: 'poroledelegation'
				}, {
					name: 'Move to Inactive',
					prop: 'poarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				nocontractorspurchaseorder: [{
					name: 'Move to Inactive',
					prop: 'poarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				cancellationpurchaseorder: [{
					name: 'Migrate PO',
					prop: 'pomigrate'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				anypurchaseorder: [{
					name: 'Transfer PO',
					prop: 'poroledelegation'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				archivedcontractor: [{
					name: 'Restore to active',
					prop: 'contractorrestore'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				cancelledcontractor: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				dtvschedule: [
					{
						name: 'Update Delegated Time Verifier',
						prop: 'dtvscheduleupdate'
					}, {
						name: 'Remove Delegated Time Verifier',
						prop: 'contractorremovetra'
					}
				],
			}
		}, {
			prop: 'sa',
			name: 'Supplier Administrator',
			path: 'admin-users',
			paths: [
				'privacy-notice',
				'help',
				'invoice-calendars',
				'timesheet-line-items',
				'admin-users',
				'admin-addons',
				'release-notes',
				'logout'
			],
			search: [],
			approve: [],
			timesheetAction: '',
			timesheetEscalation: '',
			headerCounts: false,
			actions: {
				user: [{
					name: 'Revalidate Users',	// this action needs be the first
					prop: 'revalidateusers'
				}, {
					name: 'Revoke Users',
					prop: 'revokeusers'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}]
			}
		}, {
			prop: 'readonly',
			name: 'Read Only',
			path: 'purchase-orders',
			paths: [
				'privacy-notice',
				'help',
				'purchase-orders',
				'contractors',
				'timesheets',
				'contract-changes',
				'invoices',
				'supplier-invoices',
				'blockchain-invoices',
				'reports',
				'release-notes',
				'logout'
			],
			search: [this.purchaseOrderDataObj, this.contractorDataObj, this.timesheetDataObj],
			approve: [],
			timesheetAction: '',
			timesheetEscalation: '',
			headerCounts: false,
			actions: {
				contractor: [{
					name: 'Move to Inactive',
					prop: 'contractorarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				timesheet: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				purchaseorder: [{
					name: 'Move to Inactive',
					prop: 'poarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				archivedpurchaseorder: [{
					name: 'Restore to active',
					prop: 'porestore'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				cancellationpurchaseorder: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				smartcontract: [
					{
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}
				],
				invoice: [
					{
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}
				],
				archivedcontractor: [{
					name: 'Restore to active',
					prop: 'contractorrestore'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				cancelledcontractor: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}]
			}
		}, {
			prop: 'fa',
			name: 'Finance Analyst',
			path: 'invoices',
			paths: [
				'privacy-notice',
				'help',
				'user-config',
				'purchase-orders',
				'contractors',
				'timesheets',
				'invoices',
				'supplier-invoices',
				'blockchain-invoices',
				'reports',
				'release-notes',
				'logout'
			],
			search: [this.purchaseOrderDataObj, this.contractorDataObj, this.timesheetDataObj],
			approve: [],
			timesheetAction: '',
			timesheetEscalation: '',
			headerCounts: false,
			actions: {
				contractor: [
					{
						name: 'Move to Inactive',
						prop: 'contractorarchive'
					}, {
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}
				],
				timesheet: [{
					name: 'Migrate Timesheets',
					prop: 'migratetimesheet'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				purchaseorder: [{
					name: 'Move to Inactive',
					prop: 'poarchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				archivedpurchaseorder: [{
					name: 'Restore to active',
					prop: 'porestore'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				cancellationpurchaseorder: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				anypurchaseorder: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				invoice: [{
					name: 'Force Reconciliation',
					prop: 'forcereconciliation'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				pendinginvoice: [{
					name: 'Move to Inactive',
					prop: 'invoicearchive'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				archivedinvoice: [{
					name: 'Restore to Active',
					prop: 'invoicerestore'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
					}
				],
				supplierinvoice: [
					// BCL-1902: Uncomment this section when Beth API is available
					{
						name: 'Reject Supplier Invoice',
						prop: 'supplierinvoicereject'
					}, {
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}
				],
				pendingsupplierinvoice: [
					{
						name: 'Move To Inactive',
						prop: 'supplierinvoicearchive'
					},
					// BCL-1902: Uncomment this section when Beth API is available
					{
						name: 'Reject Supplier Invoice',
						prop: 'supplierinvoicereject'
					}, {
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}
				],
				archivedsupplierinvoice: [
					{
						name: 'Restore to active',
						prop: 'supplierinvoiceactivate'
					},
					// BCL-1902: Uncomment this section when Beth API is available
					{
						name: 'Reject Supplier Invoice',
						prop: 'supplierinvoicereject'
					}, {
						name: 'Export To CSV',
						prop: 'exporttocsv'
					}
				],
				archivedcontractor: [{
					name: 'Restore to active',
					prop: 'contractorrestore'
				}, {
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				cancelledcontractor: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
				anycontractor: [{
					name: 'Export To CSV',
					prop: 'exporttocsv'
				}],
			}
		}
	];

	personaProps = {
		contractor: 'contractor',
		pm: 'pm',
		sam: 'sam',
		tra: 'tra',
		readonly: 'readonly',
		fa: 'fa'
	};

	resourceObjects = {
		po: 'Purchase Order',
		con: 'Contractor',
		ts: 'Timesheet'
	};

	/*
	Menu Item Objects - key definitions:
	label: displayed in DOM
	path: used in application routing from application root url
	*/
	mainMenuItems = [
		{
			label: 'Home',
			path: 'dashboard'
		}, {
			label: 'Claim Timesheet',
			path: 'timesheet'
		}, {
			label: 'Purchase Orders',
			path: 'purchase-orders'
		}, {
			label: 'Contractors',
			path: 'contractors'
		}, {
			label: 'Timesheets',
			path: 'timesheets'
		}, {
			label: 'Contract Changes',
			path: 'contract-changes'
		}, {
			label: 'Manage Add-Ons',
			path: 'admin-addons'
		}, {
			label: 'DTV Schedule',
			path: 'delegated-time-verifier-schedule'
		}, {
			label: 'Submit PO',
			path: 'admin-po'
		}, {
			label: 'Submit Invoice',
			path: 'admin-invoice'
		}, {
			label: 'Manage Users',
			path: 'admin-users'
		}, {
			label: 'Escalation Config',
			path: 'escalation-config'
		}, {
			label: 'Manage Invoice Calendars',
			path: 'invoice-calendars'
		}, {
			label: 'Timesheet Line Items Config',
			path: 'timesheet-line-items'
		}, {
			label: 'Invoice Reconciliations',
			path: 'invoices'
		}, {
			label: 'Supplier Invoices',
			path: 'supplier-invoices'
		}, {
			label: 'Blockchain Invoices',
			path: 'blockchain-invoices'
		}, {
			label: 'Reports',
			path: 'reports'
		}, {
			label: 'Privacy Notice',
			path: 'privacy-notice'
		}, {
			label: 'Release Notes',
			path: 'release-notes'
		}, {
			label: 'User Help',
			path: 'help'
		}, {
			label: 'User Settings',
			path: 'user-config'
		}, {
			label: 'Logout',
			path: 'logout'
		}
	];

	// Weekday localization to match back-end "start of week" ordering
	weekDays = ['Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri'];

	// Universal weekdays
	utcWeekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

	timezones = [{ 'name': 'EDT/EST', 'value': 'America/New_York' },
	{ 'name': 'CDT/CST', 'value': 'America/Chicago' },
	{ 'name': 'PDT/PST', 'value': 'America/Los_Angeles' }];

	defaultOptions = [];

	customOptions = [];

	countryCodes: any = {
		US: '897',
		UK: '866',
		IE: '754,606',	// 754 is default IE countryCode and should be the first
		CA: '649'
	};

	countryCodeSeparator = ',';

	username = '';

	// the value of totalHourTypes needs be the same as in configs
	totalHourTypes = {
		straighttime: 'totalSThours',
		standard: 'totalSThours',
		overtime: 'totalOThours',
		doubletime: 'totalDThours',
		standby: 'totalSDhours',
		callout: 'totalCOhours',
		remotecallout: 'totalRCOhours',
		onsitecallout: 'totalOCOhours'
	};

	fieldsConfigLoadedSubject: EventEmitter<void> = new EventEmitter();

	constructor(private http: HttpClient) {
		Object.keys(this.countryCodes).forEach( (key) =>{
			this.loadFieldsConfig(this.countryCodes[key]);
		});
	}

	/**
	 * fetch local asset config.csv and load the data into this.fieldConfig
	 */
	loadFieldsConfig(countryCode=null) {
		if ((countryCode === null || countryCode === this.countryCodes.US) && this.fieldConfig === null) {
			this.http.get('assets/config/config.csv', {responseType: 'text'})
				.subscribe(text => {
					this.fieldConfig = this.convertConfigCSV(text);
					this.fieldsConfigLoadedSubject.complete();
				}
			);
		}
		if (countryCode && countryCode !== this.countryCodes.US && !(countryCode in this.countryFieldConfigs)) {
			// need load country based config if it is non-US
			const countryName = this.getCountryNameByCode(countryCode);
			this.http.get('assets/config/config.' + countryName + '.csv', {responseType: 'text'})
				.subscribe(text => {
					if (countryCode.indexOf(this.countryCodeSeparator) > 0) {
						const countryCodes = countryCode.split(this.countryCodeSeparator);
						for (let i=0; i< countryCodes.length; i++) {
							this.countryFieldConfigs[countryCodes[i].trim()] = this.convertConfigCSV(text);
						}
					} else {
						this.countryFieldConfigs[countryCode] = this.convertConfigCSV(text);
					}
				});
		}
	}

	/**
	 * many components require fieldConfig onInit, this checks if that data is available (loaded via fetch)
	 */
	getIsConfigLoaded() {
		if (this.fieldConfig === null) {
			return false;
		} 
		Object.keys(this.countryCodes).forEach( (key) =>{
			if (key !== 'US' && this.countryFieldConfigs[this.countryCodes[key]] === undefined) {
				return false;
			}
		});
		return true;
	}

	extractFormData(config, form, ignoreFields = [], objects = []) {
		const extractedData = {};
		if (config.fields) {
			config.fields.forEach(field => {
				console.log('CONFIG FIELD', field);
				let ignoreConfigField = false;
				ignoreFields.forEach(ignoreField => {
					if (ignoreField === field.validate) {
						ignoreConfigField = true;
					}
				});
				if (!ignoreConfigField) {
					if (form.get(field.prop) !== undefined && form.get(field.prop) !== null) {
						console.log('FORM FIELD', form.get(field.prop));
						extractedData[field.prop] = form.get(field.prop).value;
						if (field.validate === 'boolean' && extractedData[field.prop] === '') {
							extractedData[field.prop] = false;
						}
					}
				}
			});
		}
		if (config.objects) {
			config.objects.forEach(object => {
				console.log('CONFIG OBJECT', object);
				objects.forEach(popObj => {
					if (popObj === object.prop) {
						extractedData[object.prop] = {};
						if (object.fields) {
							object.fields.forEach(field => {
								console.log('CONFIG OBJECT FIELD', field);
								if (form.get(field.prop) !== undefined && form.get(field.prop) !== null) {
									console.log('FORM FIELD', form.get(field.prop));
									extractedData[object.prop][field.prop] = form.get(field.prop).value;
								}
							});
						}
					}
				});
			});
		}
		console.log('EXTRACTED DATA', extractedData);
		return extractedData;
	}

	mergeFormData(config, extractedData, existingData, ignoreFields = [], objects = []) {
		if (config.fields) {
			config.fields.forEach(field => {
				let ignoreConfigField = false;
				ignoreFields.forEach(ignoreField => {
					if (ignoreField === field.validate) {
						ignoreConfigField = true;
					}
				});
				if (!ignoreConfigField) {
					if (extractedData[field.prop] !== undefined && extractedData[field.prop] !== null) {
						existingData[field.prop] = extractedData[field.prop];
						if (field.validate === 'boolean' && existingData[field.prop] === '') {
							existingData[field.prop] = false;
						}
					}
				}
			});
		}
		if (config.objects) {
			config.objects.forEach(object => {
				objects.forEach(popObj => {
					if (popObj === object.prop) {
						if (extractedData[object.prop]) {
							if (!existingData[object.prop]) {
								existingData[object.prop] = {};
							}
							if (object.fields) {
								object.fields.forEach(field => {
									if (extractedData[object.prop][field.prop] !== undefined && extractedData[object.prop][field.prop] !== null) {
										existingData[object.prop][field.prop] = extractedData[object.prop][field.prop];
										if (field.validate === 'boolean' && existingData[object.prop][field.prop] === '') {
											existingData[object.prop][field.prop] = false;
										}
									}
								});
							}
						}
					}
				});
			});
		}
		console.log('MERGED DATA', existingData);
		return existingData;
	}

	injectFormData(config, form, data, objects = []) {

		if (config.fields) {
			config.fields.forEach(field => {
				if (form.get(field.prop) !== undefined && form.get(field.prop) !== null) {
					form.get(field.prop).setValue(data[field.prop]);
					if (field.validate === 'boolean' && form.get(field.prop) === '') {
						form.get(field.prop).setValue(false);
					}
				}
			});
		}
		if (config.objects) {
			config.objects.forEach(object => {
				objects.forEach(popObj => {
					if (popObj === object.prop) {
						if (object.fields) {
							object.fields.forEach(field => {
								if (form.get(field.prop) !== undefined && form.get(field.prop) !== null) {
									form.get(field.prop).setValue(data[object.prop][field.prop]);
									if (field.validate === 'boolean' && form.get(field.prop) === '') {
										form.get(field.prop).setValue(false);
									}
								}
							});
						}
					}
				});
			});
		}
	}

	injectSingleFormData(prop, form, data) {
		if (form.get(prop)) {
			form.get(prop).setValue(data);
		}
	}

	getSingleFormData(prop, form) {
		return form.get(prop) ? form.get(prop).value : null;
	}

	resetTempTab() {
		this.tempTab = {
			prop: 'temp',
			name: 'Temp',
			active: false,
			persona: ['all'],
			notPersona: [],
			cached: false,
			listTab: false,
			type: 'standard',
			page: 0
		};
	}

	getRolenameById(id) {
		let rolename = '';
		if (id) {
			// convert mgr to pm
			id = id.replace(/mgr/gi, 'pm');

			// for multiple roles pm, tra
			const idArr = id.split(',');
			for (let i = 0; i < idArr.length; i++) {
				let separator = '';
				if (i !== 0) {
					separator = ', ';
				}
				const roles = this.roles.filter(role => {
					return role.id === idArr[i].trim();
				});
				if (roles && roles.length > 0) {
					rolename += separator + roles[0].itemName;
				} else {
					rolename += separator + idArr[i].trim();
				}
			}
		}
		return rolename;
	}

	showHeaderCounts() {
		return this.personas[this.personaIndex].headerCounts ? true : false;
	}

	getDataObj(dataObj: string, addons = null, countryCode = null) {
		const self = this;
		let fields: any = {};
		if (countryCode && countryCode !== this.countryCodes.US && countryCode in this.countryFieldConfigs) {
			const fieldConfig = this.countryFieldConfigs[countryCode];
			const personaConfigs = fieldConfig[this.persona];
			if (personaConfigs !== undefined) {
				fields = personaConfigs[dataObj];
			}
		} else if (this.fieldConfig[this.persona] !== undefined) {
			fields = this.fieldConfig[this.persona][dataObj];
		}

		if (addons === null) {
			return fields;
		} else {
			console.log('ADDON FIELDS', fields, addons);

			let flexifieldsMatch = -1;
			fields.objects.forEach(function (d, i) {
				if (d.prop === self.contractorAddonsProp) {
					flexifieldsMatch = i;
				}
			});
			if (flexifieldsMatch > -1) {
				fields.objects.splice(flexifieldsMatch, 1);
			}

			if (addons.length > 0) {

				const flexiObj = {
					array: false,
					name: 'Addon Data Fields',
					objects: [],
					prop: self.contractorAddonsProp,
					tablePos: 1,
					fields: []
				};

				addons.forEach(function (d, i) {
					flexiObj.fields.push({
						afterSubmit: false,
						approve: false,
						autoPop: '',
						create: true,
						edit: true,
						idProp: '',
						laxRequired: false,
						maxVal: '',
						maxWidth: 400,
						minVal: '',
						minWidth: 125,
						name: d.label,
						onlyIf: '',
						page: true,
						prop: d.id,
						required: false,
						requiredIf: '',
						search: false,
						shortTable: false,
						table: false,
						validate: d.type,
						view: true,
					});
				});
				fields['objects'].push(flexiObj);
			}

			console.log('FIELDS WITH ADDONS', fields);

			return fields;
		}

	}

	getTableFields(dataObj: string, short: boolean, countryCode=null) {
		const allFields = this.getDataObj(dataObj, null, countryCode).fields;

		const tableFields = [];
		if (allFields !== undefined) {
			allFields.forEach(function (d, i) {
				if (d.table && !short) {
					tableFields.push(d);
				}
				if (d.shortTable && short) {
					tableFields.push(d);
				}
			});
		}
		// Nested Object Level 1
		const allObjs = this.getDataObj(dataObj).objects;
		if (allObjs !== undefined) {
			allObjs.forEach(function (obj, objI) {
				const objFields = obj.fields;
				if (objFields !== undefined) {

					objFields.forEach(function (objField, objFieldI) {
						const newObjField = _.cloneDeep(objField);
						newObjField.prop = obj.prop + '.' + objField.prop;
						if (short && objField.shortTable) {
							if (obj.tablePos > -1) {
								tableFields.splice(obj.tablePos, 0, newObjField);
							} else {
								tableFields.push(newObjField);
							}
						}
						if (objField.table && !short) {
							if (obj.tablePos > -1) {
								tableFields.splice(obj.tablePos, 0, newObjField);
							} else {
								tableFields.push(newObjField);
							}
						}
					});
				}
			});
		}
		// tableFields.sort(this.sortFields);
		return tableFields;
	}

	getTableData(data, dataObj) {
		if (data !== undefined) {
			const tableConfig = this.getTableFields(dataObj, false);
			const allObjs = this.getDataObj(dataObj).objects;
			const tableData = [];
			data.forEach(function (d, i) {
				const tableItem = _.cloneDeep(d);
				if (allObjs !== undefined) {
					allObjs.forEach(function (obj, objI) {
						const objFields = obj.fields;
						const objProp = obj.prop;
						if (objFields !== undefined) {
							objFields.forEach(function (objField, objFieldI) {
								if (d[objProp] !== undefined) {
									tableItem[objProp + '.' + objField.prop] = d[objProp][objField.prop];
								}
							});
						}
					});
				}
				tableData.push(tableItem);
			});
			return tableData;
		} else {
			return [];
		}
	}

	getActions(dataObj) {
		let actions = [];
		const self = this;
		this.personas.forEach(function (persona, i) {
			if (self.persona === persona.prop && persona.actions[dataObj] !== undefined) {
				actions = persona.actions[dataObj];
			}
		});
		return actions;
	}

	getExportAction() {
		return this.exportAction;
	}

	getAction(prop) {
		let actionObj = {};
		const self = this;
		this.personas.forEach(function (persona, i) {
			if (self.persona === persona.prop) {
				console.log('GET ACTION FOR PERSONA', self.persona);
				for (const actionKey of Object.keys(persona.actions)) {
					persona.actions[actionKey].forEach(function (action, ii) {
						if (action.prop === prop) {
							actionObj = action;
						}
					});
				}
			}
		});
		if (actionObj['prop'] === undefined) {
			for (const actionKey of Object.keys(this.actions)) {
				console.log('GLOBAL ACTION KEY', actionKey);
				this.actions[actionKey].forEach(function (action, ii) {
					console.log('GLOBAL ACTION', action);
					if (action.prop === prop) {
						actionObj = action;
					}
				});
			}
		}
		return actionObj;
	}


	getTimesheetAction() {
		let timesheetAction = '';
		const self = this;
		this.personas.forEach(function (d, i) {
			if (self.persona === d.prop) {
				timesheetAction = d.timesheetAction;
			}
		});
		return timesheetAction;
	}

	getTimesheetEscalation() {
		let timesheetEscalation = '';
		const self = this;
		this.personas.forEach(function (d, i) {
			if (self.persona === d.prop) {
				timesheetEscalation = d.timesheetEscalation;
			}
		});
		return timesheetEscalation;
	}

	canDo(config, prop, doProp) {
		// console.log('CAN DO: ', config, prop, doProp)
		let canDo = false;
		config.forEach(function (d, i) {
			if (d.prop === prop && d[doProp]) {
				canDo = true;
			}
		});
		// console.log('CAN DO: ', canDo)
		return canDo;
	}

	canGo(path) {
		let canGo = false;
		let paths = [];
		const self = this;
		this.personas.forEach(function (d, i) {
			if (self.persona === d.prop) {
				paths = d.paths;
			}
		});
		// console.log('PATHS', paths);
		paths.forEach(function (d, i) {
			if (path === d) {
				canGo = true;
			}
		});
		// console.log('CAN GO', canGo);
		return canGo;
	}

	canApprove(dataObj) {
		let canApprove = false;
		let approvals = [];
		const self = this;
		this.personas.forEach(function (d, i) {
			if (self.persona === d.prop) {
				approvals = d.approve;
			}
		});
		approvals.forEach(function (d, i) {
			if (dataObj === d) {
				canApprove = true;
			}
		});
		return canApprove;
	}

	canSearch() {
		let canSearch = false;
		const self = this;
		this.personas.forEach(function (d, i) {
			if (self.persona === d.prop && d.search.length > 0) {
				canSearch = true;
			}
		});
		return canSearch;
	}

	canSearchObj(dataObj) {
		let canSearchObj = false;
		const self = this;
		this.personas.forEach(function (persona, personaI) {
			if (self.persona === persona.prop) {
				for (let i = 0; i < persona.search.length; i++) {
					if (persona.search[i] === dataObj) {
						canSearchObj = true;
					}
				}
				/*d.search.forEach(function (dd, ii) {
					if (dd === dataObj) {
						canSearchObj = true;
					}
				});*/
			}
		});
		// console.log('SEARCH OBJ', dataObj, canSearchObj);
		return canSearchObj;
	}

	adjustConfigMinWidths(configs) {
		const newConfigs = _.cloneDeep(configs);
		newConfigs.forEach(function (d, i) {
			d.minWidth = Math.floor(d.minWidth * .7);
		});
		// console.log('ADJUST CONFIG WIDTHS', newConfigs);
		return newConfigs;
	}

	/**
	 * reads CSV string and converts it into large data object for use by data table pages
	 */
	convertConfigCSV(data) {
		const dataArray = data.split(/\n/);
		dataArray.splice(0, 1);
		const personaConfigs = {};
		const totalPersonas = this.personas.length;
		const prePersonaCols = 6;
		const totalBooleans = 9;

		this.personas.forEach(function (p, pi) {

			personaConfigs[p.prop] = {};

			dataArray.forEach(function (d) {
				const arr = d.trim().split(',');

				if (personaConfigs[p.prop][arr[1]] === undefined) {
					personaConfigs[p.prop][arr[1]] = {
						fields: [],
						objects: []
					};
				}

				const obj = {
					prop: arr[5],
					name: arr[0],
					autoPop: arr[4],
					view: false,
					edit: false,
					approve: false,
					afterSubmit: false,
					search: false,
					sort: false,
					table: false,
					shortTable: false,
					page: false,
					create: false,
					required: false,
					laxRequired: false,
					idProp: arr[prePersonaCols + totalPersonas + totalBooleans],
					requiredIf: arr[prePersonaCols + totalPersonas + totalBooleans + 1],
					onlyIf: arr[prePersonaCols + totalPersonas + totalBooleans + 2],
					validate: arr[prePersonaCols + totalPersonas + totalBooleans + 3],
					minVal: arr[prePersonaCols + totalPersonas + totalBooleans + 4],
					maxVal: arr[prePersonaCols + totalPersonas + totalBooleans + 5],
					minWidth: parseInt(arr[prePersonaCols + totalPersonas + totalBooleans + 6], 10),
					maxWidth: parseInt(arr[prePersonaCols + totalPersonas + totalBooleans + 7], 10),
					helpText: arr[prePersonaCols + totalPersonas + totalBooleans + 8],
				};

				if (arr[prePersonaCols + pi] === 'v' ||
					arr[prePersonaCols + pi] === 'e' ||
					arr[prePersonaCols + pi] === 'a' ||
					arr[prePersonaCols + pi] === 'ea' ||
					arr[prePersonaCols + pi] === 'ae') {
					obj.view = true;
				}

				if (arr[prePersonaCols + pi] === 'e') {
					obj.edit = true;
				}

				if (arr[prePersonaCols + pi] === 'a') {
					obj.approve = true;
				}

				if (arr[prePersonaCols + pi] === 'ea' || arr[prePersonaCols + pi] === 'ae') {
					obj.edit = true;
					obj.approve = true;
				}

				if (arr[prePersonaCols + totalPersonas] === 'x') {
					obj.afterSubmit = true;
				}

				if (arr[prePersonaCols + totalPersonas + 1] === 'x') {
					obj.table = true;
				}

				if (arr[prePersonaCols + totalPersonas + 2] === 'x') {
					obj.shortTable = true;
				}

				if (arr[prePersonaCols + totalPersonas + 3] === 'x') {
					obj.search = true;
				}

				if (arr[prePersonaCols + totalPersonas + 4] === 'x') {
					obj.sort = true;
				}

				if (arr[prePersonaCols + totalPersonas + 5] === 'x') {
					obj.page = true;
				}

				if (arr[prePersonaCols + totalPersonas + 6] === 'x') {
					obj.create = true;
				}

				if (arr[prePersonaCols + totalPersonas + 7] === 'x') {
					obj.required = true;
				}

				if (arr[prePersonaCols + totalPersonas + 8] === 'x') {
					obj.laxRequired = true;
				}

				if (arr[2] === '' && arr[3] === '') {
					personaConfigs[p.prop][arr[1]].fields.push(obj);
				}
				if (arr[2] !== '') {
					const arr2 = arr[2].split(':');
					let tablePos2 = -1;
					if (arr2[3] !== undefined) {
						tablePos2 = parseInt(arr2[3]);
					}

					const objObj = {
						prop: arr2[0],
						name: arr2[1],
						array: arr2[2] === 'true',
						tablePos: tablePos2,
						fields: [],
						objects: []
					};
					let hasObj = false;
					personaConfigs[p.prop][arr[1]].objects.forEach(function (dd, ii) {
						if (dd.prop === objObj.prop) {
							hasObj = true;
						}
					});
					if (!hasObj) {
						personaConfigs[p.prop][arr[1]].objects.push(objObj);
					}
					let matchedObj = 0;
					personaConfigs[p.prop][arr[1]].objects.forEach(function (dd, ii) {
						if (dd.prop === objObj.prop) {
							matchedObj = ii;
						}
					});
					if (arr[3] === '') {
						personaConfigs[p.prop][arr[1]].objects[matchedObj].fields.push(obj);
					} else {
						const arr3 = arr[3].split(':');
						let tablePos3 = -1;
						if (arr3[3] !== undefined) {
							tablePos3 = parseInt(arr3[3]);
						}

						const objObjObj = {
							prop: arr3[0],
							name: arr3[1],
							array: arr3[2],
							tablePos: tablePos3,
							fields: [],
							objects: []
						};
						let hasObjObj = false;
						personaConfigs[p.prop][arr[1]].objects[matchedObj].objects.forEach(function (dd, ii) {
							if (dd.prop === objObjObj.prop) {
								hasObjObj = true;
							}
						});
						if (!hasObjObj) {
							personaConfigs[p.prop][arr[1]].objects[matchedObj].objects.push(objObjObj);
						}
						let matchedObjObj = 0;
						personaConfigs[p.prop][arr[1]].objects[matchedObj].objects.forEach(function (dd, ii) {
							if (dd.prop === objObjObj.prop) {
								matchedObjObj = ii;
							}
						});
						personaConfigs[p.prop][arr[1]].objects[matchedObj].objects[matchedObjObj].fields.push(obj);
					}
				}
			});
		});
		return personaConfigs;
	}

	getNotificationCategoryName(id) {
		if (id) {
			id = id.toLowerCase();
			if (this.resourceObjects[id]) {
				return this.resourceObjects[id] + ' Notifications';
			}
		}
		return id + ' Notifications';
	}

	getRolesByPersona() {
		let roles = this.rolesByPersona[this.persona];
		if (!roles || roles.length === 0) {
			roles = this.roles;
		}
		return roles;
	}

	getRoleID(roleText: string) {
		let id = '';
		const result = this.getRolesByPersona().filter(role => {
			const name = role.itemName.toLowerCase();
			return name.startsWith(roleText.toLowerCase());
		});
		if (result && result.length > 0) {
			id = result[0].id;
		}
		return id;
	}

	canEditCustomTimesheetLineItem(type: string) {
		let canEditCustomType = false;
		if (this.canDo(this.getDataObj(this.timesheetDataObj).fields, this.timeentryProp, 'edit')
			&& this.customOptions.length > 0) {
			const customTypes = this.customOptions.filter(option => {
				return option.value === type;
			});
			canEditCustomType = customTypes && customTypes.length > 0;
		}
		return canEditCustomType;
	}

	getCountryConfig(name: string, countrycode: string): any {
		// countryConfig is a module, countryConfig.default is an object
		const countryConfigObject = (countryConfig as any).default[name];
		let configValue;
		if (countryConfigObject) {
			configValue = countryConfigObject[countrycode];
			if (configValue === undefined) {
				// if no explicit match, use the 'default' value
				configValue = countryConfigObject['default'];
			}
		}

		return configValue;
	}

	getCountryNameByCode(code: string) {
		let countryName = '';
		const countryKeys = Object.keys(this.countryCodes).filter(countryKey => this.countryCodes[countryKey].indexOf(code) >= 0 );
		if (countryKeys.length > 0) {
			countryName = countryKeys[0];
		}
		return countryName;
	}
}
